module.exports = __webpack_public_path__ + "img/editor_tray.png?be6123de03024c5572740c2164120e3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/editor_tray.png
// module id = 276
// module chunks = 0